import { TypedUseSelectorHook, useSelector } from 'react-redux';
import { getListeAdherents, getListeAdhesions } from '../redux/AdherentRedux';
import { RootState } from '../redux/reducers';

export const useReduxSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useGetAdherent = () => {
  const listeAdherents = useReduxSelector((state) => getListeAdherents(state));
  const listeAdhesions = useReduxSelector((state) => getListeAdhesions(state));

  return {
    listeAdherents,
    listeAdhesions,
  };
};
